module.exports = __webpack_public_path__ + "static/Memoria-cdb064dd48321143d291625891e0cd44.gif";